<div class="help-view__intro-blurb" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'">
    <p>Pick one of the categories below to quickly jump to a section of help articles or scroll down to browse all articles.</p>
</div>

<ul class="help-view__navigation" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'">
    <li *ngFor="let section of helpArticles | keyvalue">
        <a (click)="onClick_scrollToAnchor(section.key); $event.preventDefault()" [href]="'#' + section.key">{{section.key | titleCasePipe:true:titleCaseOverrides}}</a>
        <ul *ngIf="section.value.length > 1">
            <ng-container *ngFor="let articleGroup of section.value">
                <li *ngIf="articleGroup.group">
                    <a (click)="onClick_scrollToAnchor(groupAnchor(section.key, articleGroup.group)); $event.preventDefault()" [href]="'#' + groupAnchor(section.key, articleGroup.group)">{{articleGroup.group}}</a>
                </li>
            </ng-container>
        </ul>
    </li>
</ul>

<ng-container *ngFor="let section of helpArticles | keyvalue">
    <section class="help-view__section" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'" [id]="section.key">
        <h2 class="help-view__copyable-title" [id]="'aria_help_'+section.key" (click)="onClick_copyBookmarkLink(section.key)">
            {{section.key | titleCasePipe:true:titleCaseOverrides}}
            <mat-icon class="help-view__link-icon">link</mat-icon>
        </h2>
        <ng-container *ngFor="let articleGroup of section.value">
            <h3 class="group-subheader help-view__copyable-title" *ngIf="articleGroup.group" [id]="groupAnchor(section.key, articleGroup.group)" (click)="onClick_copyBookmarkLink(groupAnchor(section.key, articleGroup.group))">
                {{articleGroup.group}}
                <mat-icon class="help-view__link-icon">link</mat-icon>
            </h3>
            <mat-list role="list" tabindex="0" [attr.aria-labelledby]="'aria_help_'+section.key" [ngClass]="useRailLayout ? 'rail-layout-grid' : 'layout-grid'">
                <mat-list-item *ngFor="let article of articleGroup.articles">
                    <mat-card [id]="article.bookmark">
                        <mat-card-title>{{article.title}}</mat-card-title>
                        <div [innerHtml]="article.trustedBody"></div>
                    </mat-card>
                </mat-list-item>
            </mat-list>
        </ng-container>
    </section>
</ng-container>
<button *ngIf="showScrollToTop" type="button" mat-fab aria-label="Scroll to top" class="help-view__scroll-to-top" (click)="onClick_scrollToTop()">
    <mat-icon>expand_less</mat-icon>
</button>
